export default "__VITE_ASSET__DbBnMZZQ__"